<ng-container *transloco="let t">
  <app-nav-tabs [reduceHorizontalSpacing]=true #nav>
    <app-nav-tab [title]="t('league.details.tab.basic.data')" [itemId]="1" [isChecked]="!isLeagueInvalid"
                 [showIndicator]="true">
      <ng-template>
        <app-league-basic-data [currentLeague]="currentLeague" [leagueDetailsComponentType]="componentType"
                               [languages]="languages" [organisers]="organisers" [userRole]="userRole"
                               [sports]="sports" [countries]="countries"
                               (onLeagueChange)="leagueChange($event)"/>
      </ng-template>
    </app-nav-tab>
    <app-nav-tab [title]="t('league.details.tab.events')" [itemId]="5"
                 [isChecked]="(currentLeague?.events?.length ?? 0) > 0" [showIndicator]="true">
      <ng-template>
        <ng-template [ngTemplateOutlet]="events"/>
      </ng-template>
    </app-nav-tab>
  </app-nav-tabs>
  <ng-template #events>
    <div class="admin-card">
      <app-admin-actions-header (onExportToPdf)="downloadLeagueEvents('pdf')" (onExportToXls)="downloadLeagueEvents('xlsx')">
        <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
        </div>
        <div slot="trailingWidgets">
          <div class="pe-3">
            <app-rounded-button [label]="t('league.details.select.events')" (onClick)="openEventsForLeagueList()"
                                [isDisabled]="disableEditing()"><i class="bi bi-plus-circle pe-2"></i>
            </app-rounded-button>
          </div>
        </div>
      </app-admin-actions-header>
      @if (currentLeague?.events?.length ?? 0 > 0) {
        <div class="table-responsive d-xl-block d-none">
          <app-sortable-table cssClass="table table-last-row-no-border" [items]="currentLeague?.events">
            <thead>
            <tr>
              <th scope="col" [sortBy]="['id']" class="id-column-width">
                {{ t('event.item.id') }}
              </th>
              <th scope="col" [sortBy]="['name','nameEng', 'nameIta', 'nameSlo']">
                {{ t('app.common.item.name') }}
              </th>
              <th scope="col" [sortBy]="['raceStart']" data-type="date" class="date-column-width">
                {{ t('event.item.date') }}
              </th>
              <th scope="col" [sortBy]="['status']" class="status-column-width">
                {{ t('event.item.status') }}
              </th>
              <th scope="col" class="text-end more-column-width"></th>
            </tr>
            </thead>
            <tbody>
              @for (eventItem of currentLeague?.events; track eventItem) {
                <tr>
                  <td class="center-align">{{ eventItem.id }}</td>
                  <td class="center-align">
                    <a class="test" (click)="goToEventManagement(eventItem)">
                      <app-language-output [hrLabel]="eventItem.name" [enLabel]="eventItem.nameEng"
                                           [itLabel]="eventItem.nameIta"
                                           [srLabel]="eventItem.nameSr"
                                           [bsLabel]="eventItem.nameBs"
                                           [siLabel]="eventItem.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage"
                                           [languages]="languages"/>
                    </a>
                  </td>
                  <td class="center-align">{{ eventItem.start ?? '' | localizedDate:'short' }}
                  </td>
                  <td class="center-align">
                    <div class="status-badge" [ngClass]="{'accepted': eventItem.status === 1 , 'publishing': eventItem.status === 2, 'denied': eventItem.status
                         === 0 || eventItem.status===4 || eventItem.status===8 ,'on-hold': eventItem.status === 5, 'blue':
                         eventItem.status === 3}">
                  <span class="fw-bold">
                    {{ t("event.item.status." + eventItem.status) | uppercase }}
                  </span>
                    </div>
                  </td>
                  <td class="text-end center-align">
                    <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="raceActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                      <ul aria-labelledby="raceActionsDropdown" ngbDropdownMenu>
                        <li (click)="goToEventDetails(eventItem)" ngbDropdownItem>{{ t("app.common.details") }}</li>
                        @if (!disableEditing()) {
                          <li ngbDropdownItem (click)="openEraseEventConfirmationDialog(eventItem)">
                            {{ t("app.common.delete") }}
                          </li>
                        }
                      </ul>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </app-sortable-table>
        </div>
      } @else {
        <app-empty-state-admin/>
      }
      <!--      Mobile table-->
      @for (eventItem of currentLeague?.events; let isLast = $last; track eventItem) {
        <div class="d-block d-xl-none">
          <div class="d-flex justify-content-center align-items-center mobile-table-row" [class.isLastRow]="isLast">
            <div class="flex-grow-1">
              <div class="d-flex flex-column" [class.isLastRow]="isLast">
                <div>
                  {{ t('event.item.id') }}: {{ eventItem.id }}
                </div>
                <div>
                  {{ t('app.common.item.name') }}:
                  <app-language-output [hrLabel]="eventItem.name" [enLabel]="eventItem.nameEng"
                                       [itLabel]="eventItem.nameIta"
                                       [srLabel]="eventItem.nameSr"
                                       [bsLabel]="eventItem.nameBs"
                                       [siLabel]="eventItem.nameSlo" [defaultLanguage]="eventItem?.defaultLanguage"
                                       [languages]="languages"/>
                </div>
                <div>
                  {{ t('event.item.date') }}
                  : {{ eventItem.start ?? ''| localizedDate:'short' }}
                </div>

                <div>
                  Status: {{ t("event.status." + eventItem.status) }}
                </div>
              </div>
            </div>
            <div (click)="handleDropdownClick($event)">
              <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
              <span class="menu-icon" id="raceActionsDropdownMobile" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </span>
                <ul aria-labelledby="raceActionsDropdown" ngbDropdownMenu>
                  <li (click)="goToEventDetails(eventItem)" ngbDropdownItem>{{ t("app.common.details") }}</li>
                  @if (!disableEditing()) {
                    <li ngbDropdownItem (click)="openEraseEventConfirmationDialog(eventItem)">
                      {{ t("app.common.delete") }}
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      }

    </div>
    <app-action-buttons-row [saveVisible]="false"/>
  </ng-template>

</ng-container>
